/** Rows per page for feed search, matching the feed's own page size. */
export const SEARCH_PAGE_SIZE = 10;

/**
 * The single hashtag a query is asking for, or null when it is ordinary text.
 *
 * This decides which filter the search runs: a tag match against the post's own
 * `hashtags` field, or a substring match on `content`. Getting it wrong is quiet —
 * you still get results, just from the wrong field.
 *
 * One tag at a time, deliberately: a post carries a list of hashtags, so combining
 * several would have to choose between "any of" and "all of". The former is rarely
 * what someone means and the latter needs a compound filter, so `#alpha` searches
 * that tag and anything after it is ignored rather than silently changing what the
 * search means.
 *
 * Only a *leading* hash counts. A mid-string hash is prose ("see #alpha", "C#
 * tips") and should search text. Stored tags are lowercased when saved, so the
 * query is lowercased to match.
 *
 * Lives here rather than in use-posts so it can be tested without dragging in the
 * hook's dependency graph.
 */
export const extractHashtag = (query: string): string | null => {
  const first = query.trim().split(/\s+/)[0] ?? "";
  if (!first.startsWith("#")) return null;
  return first.slice(1).toLowerCase() || null;
};
